<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="gruposProcedimentosCirurgicosRegulados"
                    :validations="validations.grupoProcedimentoCirurgicoRegulado"
                    label="Grupo de procedimento cirúrgico / Procedimento cirúrgico regulado"
                    show-default-option
                    text-field="descricao"
                    v-model="model.grupoProcedimentoCirurgicoReguladoKey"
                    value-field="key"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object, formats } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                grupoProcedimentoCirurgicoRegulado: { required: true },
            }
        },
        gruposProcedimentosCirurgicosRegulados() {

            const procedimentosCirurgicos = this.data.model.reguladores
                .find(r => r.infraestruturaId === this.regulador.infraestruturaId)
                .procedimentosCirurgicos
                .filter(pc => pc.ativo && !this.procedimentosCirurgicosReguladosDoReguladorIds.includes(pc.id))
                .map(procedimentoCirurgico => ({
                    key: `procedimento#${procedimentoCirurgico.id}`,
                    origem: 'procedimento',
                    id: procedimentoCirurgico.id,
                    codigo: procedimentoCirurgico.codigo,
                    nome: procedimentoCirurgico.nome,
                    grupoId: procedimentoCirurgico.grupoId,
                    grupoNome: procedimentoCirurgico.grupoNome,
                    descricao: procedimentoCirurgico.codigo
                        ? `${this.formatProcedimento(procedimentoCirurgico.codigo)} - ${procedimentoCirurgico.nome}`
                        : procedimentoCirurgico.nome
                }))

            const grupos = []

            procedimentosCirurgicos.forEach(procedimentoCirurgico => {

                if (!grupos.find(g => g.id === procedimentoCirurgico.grupoId)) {

                    grupos.push({
                        key: `grupo#${procedimentoCirurgico.grupoId}`,
                        origem: 'grupo',
                        id: procedimentoCirurgico.grupoId,
                        descricao: procedimentoCirurgico.grupoNome
                    })
                }
            })

            return procedimentosCirurgicos.concat(grupos).sort((a, b) => a.descricao.localeCompare(b.descricao))
        },
        procedimentosCirurgicosReguladosDoReguladorIds() {

            return this.regulador.procedimentosCirurgicos.map(pc => pc.id)
        }
    },
    data: () => ({
        model: {
            grupoProcedimentoCirurgicoReguladoKey: null,
        }
    }),
    methods: {
        add() {

            let [origem, id] = this.model.grupoProcedimentoCirurgicoReguladoKey.split('#')

            id = parseInt(id)

            if (origem === 'procedimento') {

                this.regulador.procedimentosCirurgicos.push(this.prepareData(id))
            }
            else {

                this.getProcedimentosCirurgicosIds(id)
                    .filter(id => !this.procedimentosCirurgicosReguladosDoReguladorIds.includes(id))
                    .forEach(id => this.regulador.procedimentosCirurgicos.push(this.prepareData(id)))
            }

            this.resetForm()
        },
        getProcedimentosCirurgicosIds(grupoId) {

            return this.gruposProcedimentosCirurgicosRegulados
                .filter(pc => pc.origem === 'procedimento' && pc.grupoId === grupoId)
                .map(pc => pc.id)
        },
        prepareData(procedimentoCirurgicoId) {

            return this.clone(this.gruposProcedimentosCirurgicosRegulados
                .find(pc => pc.origem === 'procedimento' && pc.id === procedimentoCirurgicoId))
        },
        resetForm() {

            this.model.grupoProcedimentoCirurgicoReguladoKey = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [object, formats],
    props: {
        data: { type: Object, required: true },
        regulador: { type: Object, required: true },
    },
}
</script>